"use client"

import React, { useEffect } from "react"
import { ThemeProvider as NextThemesProvider } from "next-themes"
import { useUser } from "@clerk/nextjs"

import useUserStore from "@/store/userStore"
import { AppProgressBar as ProgressBar } from "next-nprogress-bar"

import {
	captureReplayWorthyError,
	configureSentryUser,
	isPaidPlan,
	startTargetedReplay
} from "@/utils/sentryReplay"

function Provider({ children }) {
	const { user: clerkUser } = useUser()

	const { setUserCredits, setUserPlan, setUserEmail } = useUserStore()

	useEffect(() => {
		if (clerkUser) {
			configureSentryUser({ email: clerkUser.emailAddresses[0]?.emailAddress })

			const getOrCreateUser = async () => {
				const response = await fetch("/api/user/register", {
					method: "POST",
					headers: {
						"Content-Type": "application/json"
					}
				})

				if (!response.ok) {
					const error = await response.json().catch(() => ({}))
					throw new Error(error?.error || "Failed to initialize user")
				}

				const _user = await response.json()

				setUserCredits(_user.credits)
				setUserEmail(_user.email)
				setUserPlan(_user.plan)

				configureSentryUser({
					email: _user.email,
					plan: _user.plan,
					credits: _user.credits
				})

				if (isPaidPlan(_user.plan)) {
					startTargetedReplay("paid_user", {
						plan: _user.plan
					})
				}
			}
			getOrCreateUser().catch((error) => {
				console.error("Failed to initialize user:", error)
				captureReplayWorthyError(error, "user_initialization_failed")
			})
		}
	}, [clerkUser])

	return (
		<div>
			<ProgressBar height="10px" color="#ea580c" options={{ showSpinner: true }} shallowRouting />
			<NextThemesProvider attribute="class" defaultTheme="dark" disableTransitionOnChange>
				{children}
			</NextThemesProvider>
		</div>
	)
}

export default Provider
